import React, {useEffect, useState,} from "react";
import {lookupBidders, InviteBidderUser} from "../../api/ProjectLoader";
import {useLocation, useParams} from "react-router-dom";
import {validateEmail} from '../../api/utils';
import {Input} from "../ui/input";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {Button} from "../ui/button";
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo} from "@propelauth/react";
import {Checkbox} from "@radix-ui/react-checkbox";
import {fetchWithToken, postWithToken} from "../../api/apiBase";
import {DirectoryEntry} from "../../models/permissions";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
} from "../ui/command"
import {MultiSelectCombobox} from "../ui/comboBox";

interface InviteBidderByEmailProps extends WithLoggedInAuthInfoProps {
    onInvite: (email: string) => void;
    currentUsers: string[]
}

/*
* */
function InviteTeamMember({onInvite, currentUsers, accessToken}: InviteBidderByEmailProps) {
    const {project_id} = useParams<string>();
    // get the url parameter
    const [searchText, setSearchText] = useState<string>('');
    const [isEnabled, setIsEnabled] = useState<boolean>(false);

    const [isInviting, setIsInviting] = useState<boolean>(false);
    const [inviteSuccess, setInviteSuccess] = useState<boolean>(false);
    const [inviteError, setInviteError] = useState<string>('')

    const [selected, setSelected] = useState<string[]>([])
    const [companyDirectory, setCompanyDirectory] = useState<DirectoryEntry[]>([])
    const [message, setMessage] = useState<string>('')

    const [isOpen, setIsOpen] = useState<boolean>(false)

    useEffect(() => {
        // pull in everyone in the company ...
        fetchWithToken('/company/directory', accessToken)
            .then((data: DirectoryEntry[]) => {
                console.log(currentUsers);
                setCompanyDirectory(data.filter((x) => !currentUsers.includes(x.user.email)));
                console.log(data);
            }).catch((err) => {

        })
    }, [project_id])


    // const inputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setMessage('')
    //     setSearchText(event.target.value)
    //     if (validateEmail(event.target.value)) {
    //         setIsEnabled(true)
    //         // setSearchText(event.target.value)
    //
    //     } else {
    //         setIsEnabled(false)
    //     }
    // };


    const SendInvite = (e: any) => {
        if(selected.length !== 1) {return;}
        e.preventDefault();
        setIsInviting(true)

        postWithToken(
            `/projects/${project_id}/add_user/`,
            JSON.stringify({user_email:selected[0], project_id:project_id}),
            accessToken)
            .then((data) => {
                console.log(data)
                setInviteSuccess(true)
                setIsInviting(false)
                setMessage(data.message)
                setSelected([])

            })
            .catch((err) => {
                console.log('error', err)
                setInviteError(String(err))
                setIsInviting(false)
            })

    }

    const handleChange = (values: string[]) => {
        console.log(values)
        setSelected(values)
        if(values.length > 0){
            setIsEnabled(true)
        }
    }

    const onDialogOpenChange = () => {
        // setSearchText('')
        // setInviteError('')
    }

    return <Dialog onOpenChange={onDialogOpenChange}>
        <DialogTrigger asChild>
            <Button variant="outline" >Invite Team Member</Button>
        </DialogTrigger>
        <DialogContent className="md:max-w-md">
            <div>
            <DialogTitle className="font-normal !text-[17px] mb-4">Company Directory</DialogTitle>
                <MultiSelectCombobox
                        types={companyDirectory.map(
                            (x) =>  ({value:x.user.email, label:x.user.email }))}
                        open={isOpen}
                        setOpen={setIsOpen}
                        value={selected}
                        onChange={handleChange}
                        width = {"w-[332px]"}
                />

            </div>

            <DialogDescription className="text-base text-black">

            </DialogDescription>


            <Button onClick={SendInvite}
                    disabled={!isEnabled}
            >Invite to Project
            </Button>
            <DialogFooter className="sm:justify-start">
                {isInviting && inviteSuccess && <p>Invite Sent</p>}
                {isInviting && !inviteSuccess && <p>Inviting...</p>}
                 <p>{inviteError}</p>
                <p>{message}</p>
            </DialogFooter>
        </DialogContent>
    </Dialog>
}

export default withRequiredAuthInfo(InviteTeamMember);

